import TagManager from '@sooro-io/react-gtm-module'

import type { GTMConfig } from '@ankor-io/common/types/config'

let isInitialized = false

export const initGTM = (gtm: GTMConfig) => {
  if (isInitialized) return
  try {
    TagManager.initialize({ gtmId: gtm.id })
    isInitialized = true
  } catch (error) {
    console.error('Failed to initialize GTM:', error)
  }
}

// For testing purposes only
export const resetGTMForTesting = () => {
  isInitialized = false
}

export const setUsername = (username: string) => {
  if (!isInitialized) {
    console.warn('GTM not initialized yet, username not set')
    return
  }

  TagManager.dataLayer({ dataLayer: { username } })
  TagManager.dataLayer({ dataLayer: { event: 'user-data-set' } })
}

export const trackEvent = (event: string, data?: Record<string, unknown>) => {
  if (!isInitialized) {
    console.warn('GTM not initialized yet, event not tracked:', event)
    return
  }

  TagManager.dataLayer({
    dataLayer: {
      event,
      ...data,
    },
  })
}

export const isGTMReady = () => isInitialized
